/* eslint-disable max-len */
const React = require('react');

const InPersonPaymentsQRCode = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="40" viewBox="0 0 36 40">
    <g fill="none" fillRule="evenodd">
      <path fill="#009EE3" fillRule="nonzero" d="M13.601 22.899v8.497H5.104V22.9H13.6zm8.497 6.798v1.7H20.4v-1.7h1.7zm6.798 0v1.7h-1.699v-1.7h1.7zM17 28h1v-.014h.7v-3.388h1.699v3.4h-1.7v3.398H17V28zm-5.098-3.402H6.803v5.099h5.099v-5.099zm15.295 0v1.723h1.7v1.676h-1.7v1.7h-5.099v-5.099h5.099zm-1.7 1.7h-1.699v1.7h1.7v-1.7zm-15.295.023v1.665h-1.7v-1.665h1.7zM22.098 22v2.598H20.4L20.398 22h1.7zm6.798 0v2.598h-1.699L27.196 22h1.7zm-3.399 0v.865h-1.699L23.797 22h1.7zm3.4-14.396L28.895 16h-8.498l.001-8.396h8.497zm-15.296 0V16H5.103V7.604h8.498zm-1.7 1.699H6.804v5.099h5.099V9.303zm15.296 0h-5.099v5.099h5.099V9.303zm-8.497-1.7v1.7H17v1.699h1.7v1.7H17V14h-1.7V7.604h3.4zm-8.498 3.4v1.699h-1.7v-1.7h1.7zm15.295 0v1.699h-1.699v-1.7h1.7z" />
      <g stroke="#009EE3" strokeWidth="1.499">
        <path d="M0 6L0 0 6 0M0 26L0 32 6 32M33 6L33 0 29 0M33 26L33 32 29 32" transform="translate(1 4)" />
      </g>
      <path stroke="#009EE3" strokeWidth="1.6" d="M0 19.5h34H0z" />
    </g>
  </svg>
);

module.exports = InPersonPaymentsQRCode;
